import { Flex, FlexProps } from "@mantine/core";
import { Fragment } from "react/jsx-runtime";
import { formatByDegree, isValidTemperature } from "../../utils/temperature";

type Temperature = null | number;

interface TemperaturePointsProps extends FlexProps {
  temperatureSetPoints: Temperature[];
}

const TemperaturePoints: React.FC<TemperaturePointsProps> = ({
  temperatureSetPoints,
  ...flexProps
}) => {
  return (
    <Flex gap={4} wrap={"wrap"} align={"center"} {...flexProps}>
      {temperatureSetPoints &&
        temperatureSetPoints
          .filter(isValidTemperature)
          .map((value, index, points) => (
            <Fragment key={`temp-frag-${index}`}>
              <span>{formatByDegree(value)}</span>
              {index < points.length - 1 && <span>/</span>}
            </Fragment>
          ))}
    </Flex>
  );
};

export default TemperaturePoints;
